import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/course-eval-template-evals-action-types';

import type {List, Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type CourseEvalTemplateEvalsStore = {
    evals: List<unknown>;
    evalTemplate: Map<unknown, unknown>;
};

const initialState = (): CourseEvalTemplateEvalsStore => {
    return {
        evals: Immutable.List(),
        evalTemplate: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<CourseEvalTemplateEvalsStore> = {
    [actionTypes.GET_EVAL_TEMPLATE_SUCCESS]: (state, action) => {
        return {
            evalTemplate: action.data,
        };
    },
    [actionTypes.GET_EVALS_SUCCESS]: (state, action) => {
        return {
            evals: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseEvalTemplateEvalsStore>(initialState(), actionsMap);
